<!-- Backdrop -->
<div (click)="close()" class="fixed inset-0 z-40 bg-black/60 backdrop-blur-xs transition-opacity duration-300 ease-out" [class.opacity-100]="cartService.isCartOpen()"
  [class.opacity-0]="!cartService.isCartOpen()" [class.pointer-events-auto]="cartService.isCartOpen()" [class.pointer-events-none]="!cartService.isCartOpen()"></div>

<!-- Cart Drawer Container -->
<div class="fixed inset-y-0 right-0 z-50 w-full max-w-lg bg-surface shadow-2xl transition-transform duration-300 ease-out flex flex-col"
  [class.translate-x-0]="cartService.isCartOpen()" [class.translate-x-full]="!cartService.isCartOpen()">
  <!-- Drawer Header -->
  <div class="flex items-center justify-between px-5 py-4 border-b border-border bg-surface shrink-0">
    <div class="flex items-center gap-2.5">
      <div class="w-9 h-9 rounded-full bg-primary/10 text-primary flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
        </svg>
      </div>
      <div>
        <h2 class="text-lg font-bold text-main">{{ 'CART.TITLE' | translate }}</h2>
        <span class="text-xs text-muted">
          {{ cartService.itemCount() }} {{ (cartService.itemCount() === 1 ? 'CART.ITEM' : 'CART.ITEMS') | translate }}
        </span>
      </div>
    </div>

    <button (click)="close()" class="w-9 h-9 flex items-center justify-center rounded-full text-muted hover:text-main hover:bg-surface-hover transition-colors" aria-label="Close">
      <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Order Type Segmented Selector -->
  <div class="px-5 pt-3 pb-2 bg-surface border-b border-border/60 shrink-0">
    @if (cartService.canSwitchOrderType()) {
    <div class="flex p-1 bg-background rounded-xl border border-border">
      <!-- Dine-In Option -->
      <button type="button" (click)="setOrderType(OnlineOrderType.DINE_IN)" [disabled]="!tableID()"
        class="flex-1 flex items-center justify-center gap-1.5 py-1.5 px-3 rounded-lg text-xs font-semibold transition-all duration-200"
        [class.bg-surface]="cartService.orderType() === OnlineOrderType.DINE_IN" [class.text-primary]="cartService.orderType() === OnlineOrderType.DINE_IN"
        [class.shadow-xs]="cartService.orderType() === OnlineOrderType.DINE_IN" [class.text-muted]="cartService.orderType() !== OnlineOrderType.DINE_IN"
        [class.opacity-50]="!tableID()" [class.cursor-not-allowed]="!tableID()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-3.5 h-3.5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.549" />
        </svg>
        <span>{{ 'CART.DINE_IN' | translate }}</span>
        @if (tableID() && cartService.orderType() === OnlineOrderType.DINE_IN) {
        <span class="px-1.5 py-0.5 rounded-full bg-primary/10 text-primary text-[10px] font-bold">
          {{ tableDisplayName() }}
        </span>
        }
      </button>

      <!-- Pickup Option -->
      <button type="button" (click)="setOrderType(OnlineOrderType.PICKUP)"
        class="flex-1 flex items-center justify-center gap-1.5 py-1.5 px-3 rounded-lg text-xs font-semibold transition-all duration-200"
        [class.bg-surface]="cartService.orderType() === OnlineOrderType.PICKUP" [class.text-primary]="cartService.orderType() === OnlineOrderType.PICKUP"
        [class.shadow-xs]="cartService.orderType() === OnlineOrderType.PICKUP" [class.text-muted]="cartService.orderType() !== OnlineOrderType.PICKUP">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-3.5 h-3.5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75" />
        </svg>
        <span>{{ 'CART.PICKUP' | translate }}</span>
      </button>
    </div>
    } @else {
    <!-- Single Mode Badge -->
    <div class="flex items-center justify-between p-2.5 rounded-xl bg-background border border-border text-xs">
      <div class="flex items-center gap-2.5">
        @if (cartService.orderType() === OnlineOrderType.DINE_IN) {
        <div class="w-7 h-7 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.549" />
          </svg>
        </div>
        <div class="flex flex-col">
          <span class="font-bold text-main">{{ 'CART.DINE_IN' | translate }}</span>
          @if (tableID()) {
          <span class="text-[11px] text-muted">{{ tableDisplayName() }}</span>
          }
        </div>
        } @else {
        <div class="w-7 h-7 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75" />
          </svg>
        </div>
        <div class="flex flex-col">
          <span class="font-bold text-main">{{ 'CART.PICKUP' | translate }}</span>
          @if (!tableID()) {
          <span class="text-[11px] text-muted">{{ 'CART.NO_TABLE_HINT' | translate }}</span>
          }
        </div>
        }
      </div>
    </div>
    }

    @if (!tableID() && cartService.orderType() === OnlineOrderType.PICKUP && cartService.canSwitchOrderType()) {
    <p class="text-[11px] text-muted text-center mt-1.5">
      {{ 'CART.NO_TABLE_HINT' | translate }}
    </p>
    }
  </div>

  <!-- Cart Items Scroll Area -->
  <div #scrollArea class="flex-1 overflow-y-auto px-5 pt-4 pb-16 space-y-4 scroll-smooth">
    @if (cartService.orderItems().length === 0) {
    <!-- Empty State -->
    <div class="flex flex-col items-center justify-center h-full py-16 text-center space-y-3">
      <div class="w-20 h-20 rounded-full bg-surface-hover border border-border flex items-center justify-center text-muted/60">
        <svg class="w-10 h-10" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
        </svg>
      </div>
      <div>
        <h3 class="font-semibold text-main text-base">{{ 'CART.EMPTY_TITLE' | translate }}</h3>
        <p class="text-sm text-muted mt-1 max-w-xs">{{ 'CART.EMPTY_DESC' | translate }}</p>
      </div>
    </div>
    } @else {
    <!-- Items List -->
    <div class="space-y-3">
      @for (item of cartService.orderItems(); track item.id) {
      <div class="p-3 rounded-xl border transition-colors flex flex-col gap-2" [class.border-border]="item.product?.IsSellable !== false"
        [class.bg-surface-hover/50]="item.product?.IsSellable !== false" [class.hover:bg-surface-hover]="item.product?.IsSellable !== false"
        [class.border-red-300]="item.product?.IsSellable === false" [class.dark:border-red-900/60]="item.product?.IsSellable === false"
        [class.bg-red-50/20]="item.product?.IsSellable === false">
        <!-- Item Title & Price & Remove -->
        <div class="flex items-start justify-between gap-3">
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-1.5 flex-wrap">
              <h4 class="font-semibold text-sm leading-snug" [class.text-main]="item.product?.IsSellable !== false" [class.text-muted]="item.product?.IsSellable === false">
                {{ getDisplayText(item.Name) }}
              </h4>
              @if (item.product?.IsSellable === false) {
              <span class="text-[10px] font-bold text-red-600 bg-red-100 dark:bg-red-950/40 dark:text-red-400 px-2 py-0.5 rounded-full whitespace-nowrap">
                {{ 'PRODUCT.UNAVAILABLE' | translate }}
              </span>
              }
            </div>
            <div class="text-xs text-muted mt-0.5">
              {{ item.UnitBasePrice | formatPrice:currencyPrecision:companyCurrency }}
            </div>
          </div>

          <div class="flex items-center gap-2 shrink-0">
            <span class="font-bold text-sm text-main">
              {{ item.OrderItemTotalPayable | formatPrice:currencyPrecision:companyCurrency }}
            </span>
            <button type="button" (click)="removeItem(item)"
              class="w-7 h-7 flex items-center justify-center rounded-lg text-muted/80 hover:text-red-500 hover:bg-red-50 transition-colors" aria-label="Remove item">
              <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Features / Options list -->
        @if (item.OrderItemFeature && item.OrderItemFeature.length > 0) {
        <div class="pl-2 border-l-2 border-primary/30 space-y-1 text-xs text-muted">
          @for (opt of item.OrderItemFeature; track opt.id) {
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-1.5 min-w-0">
              @if (opt.Type === OptionType.REMOVABLE) {
              <span class="px-1.5 py-0.5 rounded text-[10px] font-bold bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300 shrink-0">
                [{{ 'OPTION.REMOVED_PREFIX' | translate }}]
              </span>
              <span class="truncate text-muted line-through">{{ getDisplayText(opt.Name) }}</span>
              } @else if (opt.Type === OptionType.SIZE) {
              <span class="truncate font-medium text-main">{{ getDisplayText(opt.Name) }}</span>
              } @else if (opt.Type === OptionType.MULTIPLY) {
              <span class="truncate text-main">{{ getDisplayText(opt.Name) }}</span>
              } @else if (opt.Type === OptionType.DISCOUNT_PERCENTAGE || opt.Type === OptionType.DISCOUNT_AMOUNT) {
              <span class="truncate text-emerald-600 dark:text-emerald-400 font-medium">{{ getDisplayText(opt.Name) }}</span>
              } @else {
              <span class="truncate">+ {{ getDisplayText(opt.Name) }}{{ (opt.Quantity && opt.Quantity > 1) ? ' (x' + opt.Quantity + ')' : '' }}</span>
              }
            </div>

            <!-- Price/Badge on Right -->
            <div class="shrink-0 ml-2">
              @if (opt.Type === OptionType.REMOVABLE || opt.Type === OptionType.SIZE) {
              <!-- No price display for REMOVABLE and SIZE -->
              } @else if (opt.Type === OptionType.MULTIPLY) {
              <span class="font-semibold text-primary">x{{ formatMultiplier(opt.Modifier) }}</span>
              } @else if (opt.Type === OptionType.DISCOUNT_PERCENTAGE) {
              <span class="font-bold text-emerald-600 dark:text-emerald-400">-%{{ formatMultiplier(opt.Modifier) }}%</span>
              } @else if (opt.Type === OptionType.DISCOUNT_AMOUNT) {
              <span class="font-bold text-emerald-600 dark:text-emerald-400">-{{ opt.Modifier | formatPrice:currencyPrecision:companyCurrency }}</span>
              } @else if (opt.Modifier && opt.Modifier > 0) {
              <span class="text-primary font-medium">+{{ (opt.Modifier * (opt.Quantity || 1)) | formatPrice:currencyPrecision:companyCurrency }}</span>
              }
            </div>
          </div>
          }
        </div>
        }

        <!-- Special note -->
        @if (item.Description) {
        <div class="text-xs text-muted italic flex items-center gap-1.5 bg-background px-2 py-1 rounded-md">
          <svg class="w-3.5 h-3.5 text-muted shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
          </svg>
          <span class="truncate">{{ item.Description }}</span>
        </div>
        }

        <!-- Bottom Row: Quantity Stepper -->
        <div class="flex items-center justify-between pt-1 border-t border-border/40">
          <span class="text-xs text-muted">{{ 'CART.QUANTITY' | translate }}:</span>
          <div class="flex items-center rounded-lg border border-border bg-surface shadow-2xs">
            <button type="button" (click)="updateQuantity(item, -1)"
              class="w-7 h-7 flex items-center justify-center text-muted hover:text-main hover:bg-surface-hover rounded-l-lg transition-colors" aria-label="Decrease quantity">
              <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M20 12H4" />
              </svg>
            </button>
            <span class="w-8 text-center text-xs font-bold text-main select-none">
              {{ item.Quantity }}
            </span>
            <button type="button" (click)="updateQuantity(item, 1)"
              class="w-7 h-7 flex items-center justify-center text-muted hover:text-main hover:bg-surface-hover rounded-r-lg transition-colors" aria-label="Increase quantity">
              <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Order Notes Textarea -->
    <div class="pt-2">
      <label class="block text-xs font-semibold text-main mb-1.5">
        {{ 'CART.ORDER_NOTES' | translate }}
      </label>
      <textarea [(ngModel)]="cartService.orderNotes" rows="2" placeholder="{{ 'CART.ORDER_NOTES_PLACEHOLDER' | translate }}"
        class="w-full text-xs rounded-xl border border-border bg-background p-2.5 text-main placeholder:text-muted focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-all resize-none"></textarea>
    </div>

    <!-- Payment Method Selector -->
    <div class="pt-2">
      <div class="flex items-center justify-between mb-1.5">
        <label class="text-xs font-semibold text-main">
          {{ 'PAYMENT.METHOD_TITLE' | translate }}
        </label>
        @if (cartService.isPaymentRequired()) {
        <span class="px-2 py-0.5 rounded-full text-[10px] font-bold bg-amber-500/15 text-amber-700 dark:text-amber-400">
          {{ 'PAYMENT.REQUIRED_BADGE' | translate }}
        </span>
        }
      </div>

      <div class="grid grid-cols-2 gap-2">
        <!-- Pay at Counter / Cash -->
        <button type="button" (click)="setPaymentType(0)" [disabled]="cartService.isPaymentRequired()"
          class="flex items-center gap-2 p-2.5 rounded-xl border text-xs font-semibold transition-all duration-200 text-left cursor-pointer"
          [class.border-primary]="cartService.selectedPaymentType() === 0 && !cartService.isPaymentRequired()"
          [class.bg-primary/5]="cartService.selectedPaymentType() === 0 && !cartService.isPaymentRequired()"
          [class.text-primary]="cartService.selectedPaymentType() === 0 && !cartService.isPaymentRequired()"
          [class.border-border]="cartService.selectedPaymentType() !== 0 || cartService.isPaymentRequired()"
          [class.text-muted]="cartService.selectedPaymentType() !== 0 || cartService.isPaymentRequired()" [class.opacity-40]="cartService.isPaymentRequired()"
          [class.cursor-not-allowed]="cartService.isPaymentRequired()">
          <div class="w-6 h-6 rounded-lg bg-surface border border-border flex items-center justify-center shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-3.5 h-3.5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6H2.25m0 0v1.5m0-1.5c0-.621.504-1.125 1.125-1.125h16.5C20.496 3.375 21 3.879 21 4.5v1.5m0 0v.75a.75.75 0 0 1-.75.75H19.5m0-3h1.5m-1.5 0v3m0 0H4.5m15 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
          </div>
          <span class="truncate">{{ 'PAYMENT.PAY_AT_COUNTER' | translate }}</span>
        </button>

        <!-- Pay Online -->
        <button type="button" (click)="setPaymentType(1)"
          class="flex items-center gap-2 p-2.5 rounded-xl border text-xs font-semibold transition-all duration-200 text-left cursor-pointer"
          [class.border-primary]="cartService.selectedPaymentType() === 1" [class.bg-primary/5]="cartService.selectedPaymentType() === 1"
          [class.text-primary]="cartService.selectedPaymentType() === 1" [class.border-border]="cartService.selectedPaymentType() !== 1"
          [class.text-muted]="cartService.selectedPaymentType() !== 1">
          <div class="w-6 h-6 rounded-lg bg-surface border border-border flex items-center justify-center shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-3.5 h-3.5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
            </svg>
          </div>
          <span class="truncate">{{ 'PAYMENT.PAY_ONLINE' | translate }}</span>
        </button>
      </div>

      @if (cartService.isPaymentRequired()) {
      <p class="text-[11px] text-amber-700 dark:text-amber-400 mt-1.5 flex items-center gap-1">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3.5 h-3.5 shrink-0">
          <path fill-rule="evenodd"
            d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z"
            clip-rule="evenodd" />
        </svg>
        <span>
          {{ 'PAYMENT.REQUIRED_HINT' | translate : { type: (cartService.orderType() === OnlineOrderType.DINE_IN ? ('CART.DINE_IN' | translate) : ('CART.PICKUP' | translate)) } }}
        </span>
      </p>
      }
    </div>

    <!-- Receipt Email (Optional, shown when Pay Online is selected) -->
    @if (cartService.selectedPaymentType() === 1) {
    <div class="pt-2">
      <label class="block text-xs font-semibold text-main mb-1.5">
        {{ 'RECEIPT.EMAIL_LABEL' | translate }}
        <span class="text-muted font-normal text-[11px]">({{ 'COMMON.OPTIONAL' | translate }})</span>
      </label>
      <div class="relative">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-muted">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
          </svg>
        </div>
        <input type="email" [ngModel]="cartService.customerEmail()" (ngModelChange)="onEmailChange($event)" placeholder="{{ 'RECEIPT.EMAIL_PLACEHOLDER' | translate }}"
          class="w-full text-xs rounded-xl border border-border bg-background pl-9 pr-3 py-2.5 text-main placeholder:text-muted focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-all" />
      </div>
      <p class="text-[11px] text-muted mt-1">{{ 'RECEIPT.EMAIL_HINT' | translate }}</p>
    </div>
    }

    <!-- Tipping Selector Component -->
    <div class="pt-2">
      <div class="flex items-center justify-between mb-1.5">
        <label class="text-xs font-semibold text-main flex items-center gap-1.5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-primary">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H4.5a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
          </svg>
          {{ 'TIPPING.TITLE' | translate }}
        </label>
        @if (cartService.tipAmount() > 0) {
        <span class="text-xs font-bold text-primary">
          +{{ cartService.tipAmount() | formatPrice:currencyPrecision:companyCurrency }}
        </span>
        }
      </div>

      <!-- Tip Presets -->
      <div class="grid grid-cols-5 gap-1.5">
        @for (preset of tipPresets; track preset) {
        <button type="button" (click)="setTipPreset(preset)"
          class="flex flex-col items-center justify-center py-2 px-1 rounded-xl border text-center transition-all duration-200 cursor-pointer text-xs"
          [class.border-primary]="cartService.selectedTipPreset() === preset" [class.bg-primary/10]="cartService.selectedTipPreset() === preset"
          [class.text-primary]="cartService.selectedTipPreset() === preset" [class.font-bold]="cartService.selectedTipPreset() === preset"
          [class.border-border]="cartService.selectedTipPreset() !== preset" [class.bg-surface]="cartService.selectedTipPreset() !== preset"
          [class.text-main]="cartService.selectedTipPreset() !== preset" [class.hover:border-primary/50]="cartService.selectedTipPreset() !== preset">
          @if (preset === 'custom') {
          <span class="text-[11px] leading-tight">{{ 'TIPPING.CUSTOM' | translate }}</span>
          } @else if (preset === 0) {
          <span class="text-[11px] leading-tight">{{ 'TIPPING.NONE' | translate }}</span>
          } @else {
          <span class="font-bold leading-tight">{{ preset }}%</span>
          <span class="text-[10px] text-muted opacity-80 mt-0.5 leading-none">
            {{ getPresetTipAmount(preset) | formatPrice:currencyPrecision:companyCurrency }}
          </span>
          }
        </button>
        }
      </div>

      <!-- Custom Tip Input -->
      @if (cartService.selectedTipPreset() === 'custom') {
      <div class="mt-2 flex items-center gap-2">
        <div class="relative flex-1">
          <span class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-xs font-bold text-muted">
            {{ companyCurrency }}
          </span>
          <input type="number" min="0" step="any" [ngModel]="cartService.customTipAmount()" (ngModelChange)="onCustomTipInput($event)" placeholder="0.00"
            class="w-full text-xs font-bold rounded-xl border border-border bg-background pl-7 pr-3 py-2 text-main focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-all" />
        </div>
      </div>
      }
      <div #tippingEnd class="h-1 pointer-events-none"></div>
    </div>
    }
  </div>

  <!-- Drawer Footer -->
  @if (cartService.orderItems().length > 0) {
  <div class="p-5 border-t border-border bg-surface shrink-0 space-y-3">
    <!-- Restaurant Closed Notice -->
    @if (!cartService.isRestaurantOpen()) {
    <div class="p-3 rounded-xl bg-rose-500/10 border border-rose-500/20 text-rose-700 dark:text-rose-400 text-xs flex items-center gap-2">
      <svg class="w-4 h-4 shrink-0 text-rose-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>
      <div class="flex-1 font-medium">
        <span class="font-bold">{{ 'OPERATING_HOURS.CURRENTLY_CLOSED' | translate }}.</span>
        <span class="ml-1">
          @if (cartService.operatingStatus().messageKey === 'OPERATING_HOURS.OPENS_TODAY_AT') {
          {{ 'OPERATING_HOURS.OPENS_TODAY_AT' | translate : { time: cartService.operatingStatus().opensAtTime } }}
          } @else if (cartService.operatingStatus().messageKey === 'OPERATING_HOURS.OPENS_TOMORROW_AT') {
          {{ 'OPERATING_HOURS.OPENS_TOMORROW_AT' | translate : { time: cartService.operatingStatus().opensAtTime } }}
          } @else if (cartService.operatingStatus().messageKey === 'OPERATING_HOURS.OPENS_DAY_AT') {
          {{ 'OPERATING_HOURS.OPENS_DAY_AT' | translate : { day: cartService.operatingStatus().nextOpenDay, time: cartService.operatingStatus().opensAtTime } }}
          } @else {
          {{ 'OPERATING_HOURS.CLOSED_TODAY' | translate }}
          }
        </span>
      </div>
    </div>
    }

    <!-- Min Order Total Helper -->
    @if (cartService.isBelowMinOrder()) {
    <div class="p-3 rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-800 dark:text-amber-300 text-xs flex items-center gap-2">
      <svg class="w-4 h-4 shrink-0 text-amber-600 dark:text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
      </svg>
      <span class="flex-1 font-medium">
        {{ 'LIMITS.MIN_ORDER_HELP' | translate : { remaining: (cartService.minOrderRemaining() | formatPrice:currencyPrecision:companyCurrency), min: (cartService.minOrderTotal() |
        formatPrice:currencyPrecision:companyCurrency) } }}
      </span>
    </div>
    }

    <!-- Max Order Total Warning -->
    @if (cartService.isAboveMaxOrder()) {
    <div class="p-3 rounded-xl bg-rose-500/10 border border-rose-500/20 text-rose-700 dark:text-rose-400 text-xs flex items-center gap-2">
      <svg class="w-4 h-4 shrink-0 text-rose-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
      </svg>
      <span class="flex-1 font-medium">
        {{ 'LIMITS.MAX_ORDER_WARN' | translate : { max: (cartService.maxOrderTotal() | formatPrice:currencyPrecision:companyCurrency) } }}
      </span>
    </div>
    }

    <!-- Location Permission Blocked Warning -->
    @if (settingsService.locationCheckSettings().Enabled && geoService.permissionState() === 'denied') {
    <div class="p-3 rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-800 dark:text-amber-300 text-xs flex items-start gap-2.5">
      <svg class="w-4 h-4 shrink-0 mt-0.5 text-amber-600 dark:text-amber-400" fill="none" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
      </svg>
      <div class="flex-1 space-y-1">
        <div class="font-bold">{{ 'LOCATION.PERMISSION_REQUIRED' | translate }}</div>
        <p class="text-[11px] leading-relaxed text-muted">{{ 'LOCATION.BLOCKED_ALERT' | translate }}</p>
        <button type="button" (click)="geoService.checkPermissionState()" class="mt-1 text-[11px] font-semibold underline text-primary cursor-pointer">
          {{ 'LOCATION.RECHECK_BUTTON' | translate }}
        </button>
      </div>
    </div>
    }

    <!-- Unsellable Items Warning Banner -->
    @if (cartService.hasUnsellableItems()) {
    <div class="p-3 rounded-xl bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-900/50 text-red-700 dark:text-red-300 text-xs flex items-start gap-2">
      <svg class="w-4 h-4 shrink-0 mt-0.5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
      </svg>
      <span class="flex-1">{{ 'ERRORS.UNSELLABLE_ITEMS_IN_CART' | translate }}</span>
    </div>
    }

    <!-- Error Message Banner from Server/Validation -->
    @if (cartService.submitError()) {
    <div class="p-3 rounded-xl bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-900/50 text-red-700 dark:text-red-300 text-xs flex items-start gap-2">
      <svg class="w-4 h-4 shrink-0 mt-0.5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
      </svg>
      <span class="flex-1">{{ cartService.submitError() }}</span>
    </div>
    }

    <!-- Financial Breakdown -->
    <div class="space-y-1.5 text-xs">
      <div class="flex justify-between text-muted">
        <span>{{ 'CART.SUBTOTAL' | translate }}</span>
        <span>{{ cartService.grossTotal() | formatPrice:currencyPrecision:companyCurrency }}</span>
      </div>
      @if (cartService.taxTotal() > 0) {
      <div class="flex justify-between text-muted">
        <span>{{ 'CART.TAX' | translate }}</span>
        <span>{{ cartService.taxTotal() | formatPrice:currencyPrecision:companyCurrency }}</span>
      </div>
      }
      @if (cartService.tipAmount() > 0) {
      <div class="flex justify-between text-muted">
        <span>{{ 'TIPPING.BREAKDOWN_LABEL' | translate }}</span>
        <span class="text-primary font-medium">+{{ cartService.tipAmount() | formatPrice:currencyPrecision:companyCurrency }}</span>
      </div>
      }
      @if (cartService.deliveryFee() > 0) {
      <div class="flex justify-between text-muted">
        <span>{{ 'CART.DELIVERY_FEE' | translate }}</span>
        <span>{{ cartService.deliveryFee() | formatPrice:currencyPrecision:companyCurrency }}</span>
      </div>
      }
      <div class="flex justify-between text-base font-bold text-main pt-1.5 border-t border-border">
        <span>{{ 'CART.TOTAL' | translate }}</span>
        <span class="text-primary">{{ cartService.finalPayableTotal() | formatPrice:currencyPrecision:companyCurrency }}</span>
      </div>
    </div>

    <!-- Action Button -->
    <button type="button" (click)="onSendOrder()" [disabled]="cartService.isSubmitting() || cartService.hasUnsellableItems()"
      class="w-full py-3.5 px-4 rounded-xl font-bold text-sm shadow-md transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer"
      [class.bg-primary]="cartService.canSubmitOrder()" [class.hover:bg-primary/90]="cartService.canSubmitOrder()" [class.text-primary-foreground]="cartService.canSubmitOrder()"
      [class.hover:shadow-lg]="cartService.canSubmitOrder()" [class.bg-neutral-200]="!cartService.canSubmitOrder()" [class.dark:bg-neutral-800]="!cartService.canSubmitOrder()"
      [class.text-neutral-500]="!cartService.canSubmitOrder()" [class.dark:text-neutral-400]="!cartService.canSubmitOrder()" [class.opacity-75]="!cartService.canSubmitOrder()">
      @if (cartService.isSubmitting()) {
      <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <span>{{ 'CART.SUBMITTING' | translate }}</span>
      } @else if (cartService.hasUnsellableItems()) {
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
      </svg>
      <span>{{ 'PRODUCT.UNAVAILABLE' | translate }}</span>
      } @else if (!cartService.isRestaurantOpen()) {
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>
      <span>{{ 'OPERATING_HOURS.CURRENTLY_CLOSED' | translate }}</span>
      } @else if (cartService.selectedPaymentType() === 1) {
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
      </svg>
      <span>{{ 'PAYMENT.PAY_ONLINE' | translate }} • {{ cartService.finalPayableTotal() | formatPrice:currencyPrecision:companyCurrency }}</span>
      } @else {
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-4 h-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
      </svg>
      <span>{{ 'CART.SEND_ORDER' | translate }} • {{ cartService.finalPayableTotal() | formatPrice:currencyPrecision:companyCurrency }}</span>
      }
    </button>
  </div>
  }
</div>